
const w2wSleep = (ms) => new Promise(resolve => setTimeout(resolve, ms));

/* Перевірка підтримки webp, додавання класу webp або no-webp для HTML */
function isWebp() {
	// Проверка поддержки webp
	function testWebP(callback) {
		let webP = new Image();
		webP.onload = webP.onerror = function () {
			callback(webP.height == 2);
		};
		webP.src =
			'data:image/webp;base64,UklGRjoAAABXRUJQVlA4IC4AAACyAgCdASoCAAIALmk0mk0iIiIiIgBoSygABc6WWgAA/veff/0PP8bA//LwYAAA';
	}
	// Додавання класу _webp або _no-webp для HTML
	testWebP(function (support) {
		let className = support === true ? 'webp' : 'no-webp';
		document.documentElement.classList.add(className);
	});
}
/* Перевірка мобільного браузера */
let isMobile = {
	Android: function () {
		return navigator.userAgent.match(/Android/i);
	},
	BlackBerry: function () {
		return navigator.userAgent.match(/BlackBerry/i);
	},
	iOS: function () {
		return navigator.userAgent.match(/iPhone|iPad|iPod|iOS/i);
	},
	Opera: function () {
		return navigator.userAgent.match(/Opera Mini/i);
	},
	Windows: function () {
		return navigator.userAgent.match(/IEMobile/i);
	},
	any: function () {
		return (
			isMobile.Android() ||
			isMobile.BlackBerry() ||
			isMobile.iOS() ||
			isMobile.Opera() ||
			isMobile.Windows()
		);
	},
};
function detectPlatform() {
	const userAgent = navigator.userAgent || navigator.vendor || window.opera;

	// iOS detection
	if (/iPhone|iPod|iOS/.test(userAgent) && !window.MSStream) {
		return 'iOS';
	}

	// iOS detection
	if (/iPad/.test(userAgent) && !window.MSStream) {
		return 'iOS';
	}

	// iPadOS 13+ (режим настільного сайту): UA як Macintosh, але є сенсор (на Mac maxTouchPoints зазвичай 0)
	if (
		/Macintosh/i.test(userAgent) &&
		typeof navigator.maxTouchPoints === 'number' &&
		navigator.maxTouchPoints >= 1 &&
		!window.MSStream
	) {
		return 'iOS';
	}

	// Android detection
	if (/android/i.test(userAgent)) {
		return 'Android';
	}

	// Windows detection
	if (/Win/i.test(userAgent)) {
		return 'Windows';
	}

	// macOS detection
	if (/Mac/i.test(userAgent)) {
		return 'Mac';
	}

	// Default case
	return 'Other';
}

/**
 * Handles app download link clicks inside social in-app browsers (Instagram, Facebook, etc.).
 */
class InAppBrowserDownload {
	static HOST_SUFFIXES = [
		'apps.apple.com',
		'itunes.apple.com',
		'play.google.com',
		'onelink.me',
		'appsflyer.com',
		'adjust.com',
		'adjust.io',
		'app.link',
	];

	static #initialized = false;
	static #projectAppLinkHostsCache = null;

	/**
	 * Detect if the page runs inside a social/messenger in-app browser.
	 * Returns app id (instagram, facebook, threads, tiktok, ...) or null.
	 */
	static detect() {
		const ua = navigator.userAgent || '';

		if (/Instagram/i.test(ua)) {
			return 'instagram';
		}
		if (/Barcelona/i.test(ua)) {
			return 'threads';
		}
		if (/FBAN|FBAV|FB_IAB|Messenger/i.test(ua)) {
			return 'facebook';
		}
		if (/TikTok|musical_ly/i.test(ua)) {
			return 'tiktok';
		}
		if (/Twitter/i.test(ua)) {
			return 'twitter';
		}
		if (/LinkedIn/i.test(ua)) {
			return 'linkedin';
		}
		if (/Snapchat/i.test(ua)) {
			return 'snapchat';
		}
		if (/Pinterest/i.test(ua)) {
			return 'pinterest';
		}
		if (/Reddit/i.test(ua)) {
			return 'reddit';
		}

		return null;
	}

	static #getProjectAppLinkHosts() {
		if (InAppBrowserDownload.#projectAppLinkHostsCache) {
			return InAppBrowserDownload.#projectAppLinkHostsCache;
		}

		InAppBrowserDownload.#projectAppLinkHostsCache = new Set();
		const links = window.project?.app_links;
		if (!links) {
			return InAppBrowserDownload.#projectAppLinkHostsCache;
		}

		['app_store', 'google_play', 'web'].forEach(function (key) {
			const link = links[key];
			if (!link) {
				return;
			}
			try {
				const sanitized = String(link).replace(/\{[^}]+\}/g, 'x');
				InAppBrowserDownload.#projectAppLinkHostsCache.add(
					new URL(sanitized, window.location.origin).hostname.toLowerCase()
				);
			} catch (e) {}
		});

		return InAppBrowserDownload.#projectAppLinkHostsCache;
	}

	/**
	 * Returns true when the URL points to an app store, MMP deeplink, or project download page.
	 */
	static isAppDownloadUrl(url) {
		if (!url || url.startsWith('mailto:') || url.startsWith('tel:') || url.startsWith('javascript:')) {
			return false;
		}

		let parsed;
		try {
			parsed = new URL(url, window.location.href);
		} catch (e) {
			return false;
		}

		if (parsed.protocol === 'itms-apps:' || parsed.protocol === 'market:') {
			return true;
		}

		const host = parsed.hostname.toLowerCase();

		for (let i = 0; i < InAppBrowserDownload.HOST_SUFFIXES.length; i++) {
			const suffix = InAppBrowserDownload.HOST_SUFFIXES[i];
			if (host === suffix || host.endsWith('.' + suffix)) {
				return true;
			}
		}

		if (InAppBrowserDownload.#getProjectAppLinkHosts().has(host)) {
			return true;
		}

		if (parsed.origin === window.location.origin && /\/deeplink(?:\/|$|\?)/.test(parsed.pathname)) {
			return true;
		}

		return false;
	}

	static #detectDownloadPlatform(url) {
		if (/apps\.apple\.com|itunes\.apple\.com|itms-apps:/.test(url)) {
			return 'AppStore';
		}
		if (/play\.google\.com|market:/.test(url)) {
			return 'GooglePlay';
		}
		return 'web';
	}

	/**
	 * Build a URL that asks the host app to open the target in the system browser.
	 */
	static #buildAndroidIntent(targetUrl) {
		const encoded = encodeURIComponent(targetUrl);
		try {
			const parsed = new URL(targetUrl);
			return (
				'intent://' + parsed.host + parsed.pathname + parsed.search +
				'#Intent;scheme=https;S.browser_fallback_url=' + encoded + ';end'
			);
		} catch (e) {
			return null;
		}
	}

	static buildEscapeUrl(targetUrl, app) {
		if (!targetUrl || !app) {
			return null;
		}

		if (isMobile.Android()) {
			return InAppBrowserDownload.#buildAndroidIntent(targetUrl);
		}

		const encoded = encodeURIComponent(targetUrl);

		switch (app) {
			case 'instagram':
			case 'threads':
				return 'instagram://extbrowser/?url=' + encoded;
			case 'facebook':
				return 'x-safari-' + targetUrl;
			default:
				return 'x-safari-' + targetUrl;
		}
	}

	/**
	 * Open an app-store / MMP deeplink, escaping in-app browsers when needed.
	 * Must be called from a user click handler (Instagram requires user gesture).
	 */
	static open(url, event) {
		if (event) {
			event.preventDefault();
		}

		const inAppBrowser = InAppBrowserDownload.detect();
		if (!inAppBrowser) {
			window.location.href = url;
			return false;
		}

		const escapeUrl = InAppBrowserDownload.buildEscapeUrl(url, inAppBrowser);
		window.location.href = escapeUrl || url;
		return false;
	}

	static #handleClick(event) {
		const anchor = event.target.closest('a[href]');
		if (!anchor) {
			return;
		}

		const href = anchor.getAttribute('href');
		if (!href || href.charAt(0) === '#') {
			return;
		}

		if (anchor.hasAttribute('data-skip-inapp-escape')) {
			return;
		}

		const absoluteUrl = anchor.href;
		if (!InAppBrowserDownload.isAppDownloadUrl(absoluteUrl)) {
			return;
		}

		const inAppBrowser = InAppBrowserDownload.detect();
		if (!inAppBrowser) {
			return;
		}

		// Store links work in Android in-app browsers; escape is only needed on iOS.
		if (!isMobile.iOS()) {
			return;
		}

		InAppBrowserDownload.open(absoluteUrl, event);

		if (typeof AnalyticsManager !== 'undefined' && !anchor.hasAttribute('onclick')) {
			AnalyticsManager.logEvent('Click download button', {
				platform: InAppBrowserDownload.#detectDownloadPlatform(absoluteUrl),
				in_app_browser: inAppBrowser,
			});
		}
	}

	/**
	 * Globally intercept clicks on app download links inside in-app browsers.
	 */
	static init() {
		if (InAppBrowserDownload.#initialized) {
			return;
		}
		InAppBrowserDownload.#initialized = true;

		document.addEventListener('click', InAppBrowserDownload.#handleClick, true);
	}
}

/* Додавання класу touch для HTML, якщо браузер мобільний */
function addTouchClass() {
	// Додавання класу _touch для HTML, якщо браузер мобільний
	if (isMobile.any()) document.documentElement.classList.add('touch');
}
// Додавання loaded для HTML після повного завантаження сторінки
function addLoadedClass() {
	if (!document.documentElement.classList.contains('loading')) {
		window.addEventListener('load', function () {
			setTimeout(function () {
				document.documentElement.classList.add('loaded');
			}, 0);
		});
	}
}
// Отримання хешу на адресі сайту
function getHash() {
	if (location.hash) {
		return location.hash.replace('#', '');
	}
}
// Вказівка хеша на адресу сайту
function setHash(hash) {
	hash = hash ? `#${hash}` : window.location.href.split('#')[0];
	history.pushState('', '', hash);
}
// Облік плаваючої панелі на мобільних пристроях при 100vh
function fullVHfix() {
	if (isMobile.any()) {
		window.addEventListener('resize', fixHeight);
		function fixHeight() {
			let vh = window.innerHeight * 0.01;
			document.documentElement.style.setProperty('--vh', `${vh}px`);
		}
		fixHeight();
	}
}
// Допоміжні модулі плавного розкриття та закриття об'єкта ======================================================================================================================================================================
let _slideUp = (target, duration = 500, showmore = 0) => {
	if (!target.classList.contains('_slide')) {
		target.classList.add('_slide');
		target.style.transitionProperty = 'height, margin, padding';
		target.style.transitionDuration = duration + 'ms';
		target.style.height = `${target.offsetHeight}px`;
		target.offsetHeight;
		target.style.overflow = 'hidden';
		target.style.height = showmore ? `${showmore}px` : `0px`;
		target.style.paddingTop = 0;
		target.style.paddingBottom = 0;
		target.style.marginTop = 0;
		target.style.marginBottom = 0;
		window.setTimeout(() => {
			target.hidden = !showmore ? true : false;
			!showmore ? target.style.removeProperty('height') : null;
			target.style.removeProperty('padding-top');
			target.style.removeProperty('padding-bottom');
			target.style.removeProperty('margin-top');
			target.style.removeProperty('margin-bottom');
			!showmore ? target.style.removeProperty('overflow') : null;
			target.style.removeProperty('transition-duration');
			target.style.removeProperty('transition-property');
			target.classList.remove('_slide');
			// Створюємо подію
			document.dispatchEvent(
				new CustomEvent('slideUpDone', {
					detail: {
						target: target,
					},
				}),
			);
		}, duration);
	}
};
let _slideDown = (target, duration = 500, showmore = 0) => {
	if (!target.classList.contains('_slide')) {
		target.classList.add('_slide');
		target.hidden = target.hidden ? false : null;
		showmore ? target.style.removeProperty('height') : null;
		let height = target.offsetHeight;
		target.style.overflow = 'hidden';
		target.style.height = showmore ? `${showmore}px` : `0px`;
		target.style.paddingTop = 0;
		target.style.paddingBottom = 0;
		target.style.marginTop = 0;
		target.style.marginBottom = 0;
		target.offsetHeight;
		target.style.transitionProperty = 'height, margin, padding';
		target.style.transitionDuration = duration + 'ms';
		target.style.height = height + 'px';
		target.style.removeProperty('padding-top');
		target.style.removeProperty('padding-bottom');
		target.style.removeProperty('margin-top');
		target.style.removeProperty('margin-bottom');
		window.setTimeout(() => {
			target.style.removeProperty('height');
			target.style.removeProperty('overflow');
			target.style.removeProperty('transition-duration');
			target.style.removeProperty('transition-property');
			target.classList.remove('_slide');
			// Створюємо подію
			document.dispatchEvent(
				new CustomEvent('slideDownDone', {
					detail: {
						target: target,
					},
				}),
			);
		}, duration);
	}
};
let _slideToggle = (target, duration = 500) => {
	if (target.hidden) {
		return _slideDown(target, duration);
	} else {
		return _slideUp(target, duration);
	}
};
// Допоміжні модулі блокування прокручування та стрибка ====================================================================================================================================================================================================================================================================================
let bodyLockStatus = true;
let bodyLockToggle = (delay = 500) => {
	if (document.documentElement.classList.contains('lock')) {
		bodyUnlock(delay);
	} else {
		bodyLock(delay);
	}
};
let bodyUnlock = (delay = 500) => {
	let body = document.querySelector('body');
	if (bodyLockStatus) {
		let lock_padding = document.querySelectorAll('[data-lp]');
		setTimeout(() => {
			for (let index = 0; index < lock_padding.length; index++) {
				const el = lock_padding[index];
				el.style.paddingRight = '0px';
			}
			body.style.paddingRight = '0px';
			document.documentElement.classList.remove('lock');
		}, delay);
		bodyLockStatus = false;
		setTimeout(function () {
			bodyLockStatus = true;
		}, delay);
	}
};
let bodyLock = (delay = 500) => {
	let body = document.querySelector('body');
	if (bodyLockStatus) {
		let lock_padding = document.querySelectorAll('[data-lp]');
		for (let index = 0; index < lock_padding.length; index++) {
			const el = lock_padding[index];
			el.style.paddingRight =
				window.innerWidth -
				document.querySelector('.wrapper').offsetWidth +
				'px';
		}
		body.style.paddingRight =
			window.innerWidth - document.querySelector('.wrapper').offsetWidth + 'px';
		document.documentElement.classList.add('lock');

		bodyLockStatus = false;
		setTimeout(function () {
			bodyLockStatus = true;
		}, delay);
	}
};
// Модуль роботи зі спойлерами =======================================================================================================================================================================================================================
function spollers() {
	const spollersArray = document.querySelectorAll('[data-spollers]');
	if (spollersArray.length > 0) {

		const spollersRegular = Array.from(spollersArray).filter(
			function (item, index, self) {
				return !item.dataset.spollers.split(',')[0];
			},
		);

		if (spollersRegular.length) {
			initSpollers(spollersRegular);
		}

		let mdQueriesArray = dataMediaQueries(spollersArray, 'spollers');
		if (mdQueriesArray && mdQueriesArray.length) {
			mdQueriesArray.forEach(mdQueriesItem => {

				mdQueriesItem.matchMedia.addEventListener('change', function () {
					initSpollers(mdQueriesItem.itemsArray, mdQueriesItem.matchMedia);
				});
				initSpollers(mdQueriesItem.itemsArray, mdQueriesItem.matchMedia);
			});
		}

		function initSpollers(spollersArray, matchMedia = false) {
			spollersArray.forEach(spollersBlock => {
				spollersBlock = matchMedia ? spollersBlock.item : spollersBlock;
				if (matchMedia.matches || !matchMedia) {
					spollersBlock.classList.add('_spoller-init');
					initSpollerBody(spollersBlock);
					spollersBlock.addEventListener('click', setSpollerAction);
				} else {
					spollersBlock.classList.remove('_spoller-init');
					initSpollerBody(spollersBlock, false);
					spollersBlock.removeEventListener('click', setSpollerAction);
				}
			});
		}

		function initSpollerBody(spollersBlock, hideSpollerBody = true) {
			let spollerTitles = spollersBlock.querySelectorAll('[data-spoller]');
			if (spollerTitles.length) {
				spollerTitles = Array.from(spollerTitles).filter(
					item => item.closest('[data-spollers]') === spollersBlock,
				);
				spollerTitles.forEach(spollerTitle => {
					if (hideSpollerBody) {
						spollerTitle.removeAttribute('tabindex');
						if (!spollerTitle.classList.contains('_spoller-active')) {
							spollerTitle.nextElementSibling.hidden = true;
						}
					} else {
						spollerTitle.setAttribute('tabindex', '-1');
						spollerTitle.nextElementSibling.hidden = false;
					}
				});
			}
		}
		function setSpollerAction(e) {
			const el = e.target;
			if (el.closest('[data-spoller]')) {
				const spollerTitle = el.closest('[data-spoller]');
				const spollersBlock = spollerTitle.closest('[data-spollers]');
				const oneSpoller = spollersBlock.hasAttribute('data-one-spoller');
				const spollerSpeed = spollersBlock.dataset.spollersSpeed
					? parseInt(spollersBlock.dataset.spollersSpeed)
					: 500;
				if (!spollersBlock.querySelectorAll('._slide').length) {
					if (
						oneSpoller &&
						!spollerTitle.classList.contains('_spoller-active')
					) {
						hideSpollersBody(spollersBlock);
					}
					spollerTitle.classList.toggle('_spoller-active');
					_slideToggle(spollerTitle.nextElementSibling, spollerSpeed);
					try {
						AnalyticsManager.logEvent('FAQ clicked', {value: spollerTitle.innerText.trim()});
					} catch (e) {}
				}
				e.preventDefault();
			}
		}
		function hideSpollersBody(spollersBlock) {
			const spollerActiveTitle = spollersBlock.querySelector(
				'[data-spoller]._spoller-active',
			);
			const spollerSpeed = spollersBlock.dataset.spollersSpeed
				? parseInt(spollersBlock.dataset.spollersSpeed)
				: 500;
			if (
				spollerActiveTitle &&
				!spollersBlock.querySelectorAll('._slide').length
			) {
				spollerActiveTitle.classList.remove('_spoller-active');
				_slideUp(spollerActiveTitle.nextElementSibling, spollerSpeed);
			}
		}

		const spollersClose = document.querySelectorAll('[data-spoller-close]');
		if (spollersClose.length) {
			document.addEventListener('click', function (e) {
				const el = e.target;
				if (!el.closest('[data-spollers]')) {
					spollersClose.forEach(spollerClose => {
						const spollersBlock = spollerClose.closest('[data-spollers]');
						if (spollersBlock.classList.contains('_spoller-init')) {
							const spollerSpeed = spollersBlock.dataset.spollersSpeed
								? parseInt(spollersBlock.dataset.spollersSpeed)
								: 500;
							spollerClose.classList.remove('_spoller-active');
							_slideUp(spollerClose.nextElementSibling, spollerSpeed);
						}
					});
				}
			});
		}
	}
}

// Модуль роботи з табами =======================================================================================================================================================================================================================
function tabs() {
	const tabs = document.querySelectorAll('[data-tabs]');
	let tabsActiveHash = [];

	if (tabs.length > 0) {
		const hash = getHash();
		if (hash && hash.startsWith('tab-')) {
			tabsActiveHash = hash.replace('tab-', '').split('-');
		}
		tabs.forEach((tabsBlock, index) => {
			tabsBlock.classList.add('_tab-init');
			tabsBlock.setAttribute('data-tabs-index', index);
			tabsBlock.addEventListener('click', setTabsAction);
			initTabs(tabsBlock);
		});

		// Отримання слойлерів з медіа-запитами
		let mdQueriesArray = dataMediaQueries(tabs, 'tabs');
		if (mdQueriesArray && mdQueriesArray.length) {
			mdQueriesArray.forEach(mdQueriesItem => {
				// Подія
				mdQueriesItem.matchMedia.addEventListener('change', function () {
					setTitlePosition(mdQueriesItem.itemsArray, mdQueriesItem.matchMedia);
				});
				setTitlePosition(mdQueriesItem.itemsArray, mdQueriesItem.matchMedia);
			});
		}
	}
	// Встановлення позицій заголовків
	function setTitlePosition(tabsMediaArray, matchMedia) {
		tabsMediaArray.forEach(tabsMediaItem => {
			tabsMediaItem = tabsMediaItem.item;
			let tabsTitles = tabsMediaItem.querySelector('[data-tabs-titles]');
			let tabsTitleItems = tabsMediaItem.querySelectorAll('[data-tabs-title]');
			let tabsContent = tabsMediaItem.querySelector('[data-tabs-body]');
			let tabsContentItems = tabsMediaItem.querySelectorAll('[data-tabs-item]');
			tabsTitleItems = Array.from(tabsTitleItems).filter(
				item => item.closest('[data-tabs]') === tabsMediaItem,
			);
			tabsContentItems = Array.from(tabsContentItems).filter(
				item => item.closest('[data-tabs]') === tabsMediaItem,
			);
			tabsContentItems.forEach((tabsContentItem, index) => {
				if (matchMedia.matches) {
					tabsContent.append(tabsTitleItems[index]);
					tabsContent.append(tabsContentItem);
					tabsMediaItem.classList.add('_tab-spoller');
				} else {
					tabsTitles.append(tabsTitleItems[index]);
					tabsMediaItem.classList.remove('_tab-spoller');
				}
			});
		});
	}
	// Робота з контентом
	function initTabs(tabsBlock) {
		let tabsTitles = tabsBlock.querySelectorAll('[data-tabs-titles]>*');
		let tabsContent = tabsBlock.querySelectorAll('[data-tabs-body]>*');
		const tabsBlockIndex = tabsBlock.dataset.tabsIndex;
		const tabsActiveHashBlock = tabsActiveHash[0] == tabsBlockIndex;

		if (tabsActiveHashBlock) {
			const tabsActiveTitle = tabsBlock.querySelector(
				'[data-tabs-titles]>._tab-active',
			);
			tabsActiveTitle ? tabsActiveTitle.classList.remove('_tab-active') : null;
		}
		if (tabsContent.length) {
			tabsContent = Array.from(tabsContent).filter(
				item => item.closest('[data-tabs]') === tabsBlock,
			);
			tabsTitles = Array.from(tabsTitles).filter(
				item => item.closest('[data-tabs]') === tabsBlock,
			);
			tabsContent.forEach((tabsContentItem, index) => {
				tabsTitles[index].setAttribute('data-tabs-title', '');
				tabsContentItem.setAttribute('data-tabs-item', '');

				if (tabsActiveHashBlock && index == tabsActiveHash[1]) {
					tabsTitles[index].classList.add('_tab-active');
				}
				tabsContentItem.hidden =
					!tabsTitles[index].classList.contains('_tab-active');
			});
		}
	}
	function setTabsStatus(tabsBlock) {
		let tabsTitles = tabsBlock.querySelectorAll('[data-tabs-title]');
		let tabsContent = tabsBlock.querySelectorAll('[data-tabs-item]');
		const tabsBlockIndex = tabsBlock.dataset.tabsIndex;
		function isTabsAnamate(tabsBlock) {
			if (tabsBlock.hasAttribute('data-tabs-animate')) {
				return tabsBlock.dataset.tabsAnimate > 0
					? Number(tabsBlock.dataset.tabsAnimate)
					: 500;
			}
		}
		const tabsBlockAnimate = isTabsAnamate(tabsBlock);
		if (tabsContent.length > 0) {
			const isHash = tabsBlock.hasAttribute('data-tabs-hash');
			tabsContent = Array.from(tabsContent).filter(
				item => item.closest('[data-tabs]') === tabsBlock,
			);
			tabsTitles = Array.from(tabsTitles).filter(
				item => item.closest('[data-tabs]') === tabsBlock,
			);
			tabsContent.forEach((tabsContentItem, index) => {
				if (tabsTitles[index].classList.contains('_tab-active')) {
					if (tabsBlockAnimate) {
						_slideDown(tabsContentItem, tabsBlockAnimate);
					} else {
						tabsContentItem.hidden = false;
					}
					if (isHash && !tabsContentItem.closest('.popup')) {
						setHash(`tab-${tabsBlockIndex}-${index}`);
					}
				} else {
					if (tabsBlockAnimate) {
						_slideUp(tabsContentItem, tabsBlockAnimate);
					} else {
						tabsContentItem.hidden = true;
					}
				}
			});
		}
	}
	function setTabsAction(e) {
		const el = e.target;
		if (el.closest('[data-tabs-title]')) {
			const tabTitle = el.closest('[data-tabs-title]');
			const tabsBlock = tabTitle.closest('[data-tabs]');
			if (
				!tabTitle.classList.contains('_tab-active') &&
				!tabsBlock.querySelector('._slide')
			) {
				let tabActiveTitle = tabsBlock.querySelectorAll(
					'[data-tabs-title]._tab-active',
				);
				tabActiveTitle.length
					? (tabActiveTitle = Array.from(tabActiveTitle).filter(
							item => item.closest('[data-tabs]') === tabsBlock,
					  ))
					: null;
				tabActiveTitle.length
					? tabActiveTitle[0].classList.remove('_tab-active')
					: null;
				tabTitle.classList.add('_tab-active');
				setTabsStatus(tabsBlock);
			}
			e.preventDefault();
		}
	}
}
// Модуль роботи з меню (бургер) =======================================================================================================================================================================================================================

// Модуль "показати ще" =======================================================================================================================================================================================================================
function showMore() {
	window.addEventListener('load', function (e) {
		const showMoreBlocks = document.querySelectorAll('[data-showmore]');
		let showMoreBlocksRegular;
		let mdQueriesArray;
		if (showMoreBlocks.length) {
			// Отримання звичайних об'єктів
			showMoreBlocksRegular = Array.from(showMoreBlocks).filter(
				function (item, index, self) {
					return !item.dataset.showmoreMedia;
				},
			);
			// Ініціалізація звичайних об'єктів
			showMoreBlocksRegular.length ? initItems(showMoreBlocksRegular) : null;

			document.addEventListener('click', showMoreActions);
			window.addEventListener('resize', showMoreActions);

			// Отримання об'єктів з медіа-запитами
			mdQueriesArray = dataMediaQueries(showMoreBlocks, 'showmoreMedia');
			if (mdQueriesArray && mdQueriesArray.length) {
				mdQueriesArray.forEach(mdQueriesItem => {
					// Подія
					mdQueriesItem.matchMedia.addEventListener('change', function () {
						initItems(mdQueriesItem.itemsArray, mdQueriesItem.matchMedia);
					});
				});
				initItemsMedia(mdQueriesArray);
			}
		}
		function initItemsMedia(mdQueriesArray) {
			mdQueriesArray.forEach(mdQueriesItem => {
				initItems(mdQueriesItem.itemsArray, mdQueriesItem.matchMedia);
			});
		}
		function initItems(showMoreBlocks, matchMedia) {
			showMoreBlocks.forEach(showMoreBlock => {
				initItem(showMoreBlock, matchMedia);
			});
		}
		function initItem(showMoreBlock, matchMedia = false) {
			showMoreBlock = matchMedia ? showMoreBlock.item : showMoreBlock;
			let showMoreContent = showMoreBlock.querySelectorAll(
				'[data-showmore-content]',
			);
			let showMoreButton = showMoreBlock.querySelectorAll(
				'[data-showmore-button]',
			);
			showMoreContent = Array.from(showMoreContent).filter(
				item => item.closest('[data-showmore]') === showMoreBlock,
			)[0];
			showMoreButton = Array.from(showMoreButton).filter(
				item => item.closest('[data-showmore]') === showMoreBlock,
			)[0];
			const hiddenHeight = getHeight(showMoreBlock, showMoreContent);
			if (matchMedia.matches || !matchMedia) {
				if (hiddenHeight < getOriginalHeight(showMoreContent)) {
					_slideUp(
						showMoreContent,
						0,
						showMoreBlock.classList.contains('_showmore-active')
							? getOriginalHeight(showMoreContent)
							: hiddenHeight,
					);
					showMoreButton.hidden = false;
				} else {
					_slideDown(showMoreContent, 0, hiddenHeight);
					showMoreButton.hidden = true;
				}
			} else {
				_slideDown(showMoreContent, 0, hiddenHeight);
				showMoreButton.hidden = true;
			}
		}
		function getHeight(showMoreBlock, showMoreContent) {
			let hiddenHeight = 0;
			const showMoreType = showMoreBlock.dataset.showmore
				? showMoreBlock.dataset.showmore
				: 'size';
			if (showMoreType === 'items') {
				const showMoreTypeValue = showMoreContent.dataset.showmoreContent
					? showMoreContent.dataset.showmoreContent
					: 3;
				const showMoreItems = showMoreContent.children;
				for (let index = 1; index < showMoreItems.length; index++) {
					const showMoreItem = showMoreItems[index - 1];
					hiddenHeight += showMoreItem.offsetHeight;
					if (index == showMoreTypeValue) break;
				}
			} else {
				const showMoreTypeValue = showMoreContent.dataset.showmoreContent
					? showMoreContent.dataset.showmoreContent
					: 150;
				hiddenHeight = showMoreTypeValue;
			}
			return hiddenHeight;
		}
		function getOriginalHeight(showMoreContent) {
			let parentHidden;
			let hiddenHeight = showMoreContent.offsetHeight;
			showMoreContent.style.removeProperty('height');
			if (showMoreContent.closest(`[hidden]`)) {
				parentHidden = showMoreContent.closest(`[hidden]`);
				parentHidden.hidden = false;
			}
			let originalHeight = showMoreContent.offsetHeight;
			parentHidden ? (parentHidden.hidden = true) : null;
			showMoreContent.style.height = `${hiddenHeight}px`;
			return originalHeight;
		}
		function showMoreActions(e) {
			const targetEvent = e.target;
			const targetType = e.type;
			if (targetType === 'click') {
				if (targetEvent.closest('[data-showmore-button]')) {
					const showMoreButton = targetEvent.closest('[data-showmore-button]');
					const showMoreBlock = showMoreButton.closest('[data-showmore]');
					const showMoreContent = showMoreBlock.querySelector(
						'[data-showmore-content]',
					);
					const showMoreSpeed = showMoreBlock.dataset.showmoreButton
						? showMoreBlock.dataset.showmoreButton
						: '500';
					const hiddenHeight = getHeight(showMoreBlock, showMoreContent);
					if (!showMoreContent.classList.contains('_slide')) {
						showMoreBlock.classList.contains('_showmore-active')
							? _slideUp(showMoreContent, showMoreSpeed, hiddenHeight)
							: _slideDown(showMoreContent, showMoreSpeed, hiddenHeight);
						showMoreBlock.classList.toggle('_showmore-active');
					}
				}
			} else if (targetType === 'resize') {
				showMoreBlocksRegular && showMoreBlocksRegular.length
					? initItems(showMoreBlocksRegular)
					: null;
				mdQueriesArray && mdQueriesArray.length
					? initItemsMedia(mdQueriesArray)
					: null;
			}
		}
	});
}
// Модуль "Ripple effect" =======================================================================================================================================================================================================================
function rippleEffect() {
	// Подія кліку на кнопці
	document.addEventListener('click', function (e) {
		const targetItem = e.target;
		if (targetItem.closest('[data-ripple]')) {
			// Константи
			const button = targetItem.closest('[data-ripple]');
			const ripple = document.createElement('span');
			const diameter = Math.max(button.clientWidth, button.clientHeight);
			const radius = diameter / 2;

			// Формування елементу
			ripple.style.width = ripple.style.height = `${diameter}px`;
			ripple.style.left = `${
				e.pageX - (button.getBoundingClientRect().left + scrollX) - radius
			}px`;
			ripple.style.top = `${
				e.pageY - (button.getBoundingClientRect().top + scrollY) - radius
			}px`;
			ripple.classList.add('ripple');

			// Видалення існуючого елементу (опціонально)
			button.dataset.ripple === 'once' && button.querySelector('.ripple')
				? button.querySelector('.ripple').remove()
				: null;

			// Додавання елементу
			button.appendChild(ripple);

			// Отримання часу дії анімації
			const timeOut = getAnimationDuration(ripple);

			// Видалення елементу
			setTimeout(() => {
				ripple ? ripple.remove() : null;
			}, timeOut);

			// Функтія отримання часу дії анімації
			function getAnimationDuration() {
				const aDuration = window.getComputedStyle(ripple).animationDuration;
				return aDuration.includes('ms')
					? aDuration.replace('ms', '')
					: aDuration.replace('s', '') * 1000;
			}
		}
	});
}
// Модуль "Сustom сursor" =======================================================================================================================================================================================================================
function customCursor(isShadowTrue) {
	const wrapper = document.querySelector('[data-custom-cursor]')
		? document.querySelector('[data-custom-cursor]')
		: document.documentElement;
	if (wrapper && !isMobile.any()) {
		// Створюємо та додаємо об'єкт курсору
		const cursor = document.createElement('div');
		cursor.classList.add('fls-cursor');
		cursor.style.opacity = 0;
		cursor.insertAdjacentHTML(
			'beforeend',
			`<span class="fls-cursor__pointer"></span>`,
		);
		isShadowTrue
			? cursor.insertAdjacentHTML(
					'beforeend',
					`<span class="fls-cursor__shadow"></span>`,
			  )
			: null;
		wrapper.append(cursor);

		const cursorPointer = document.querySelector('.fls-cursor__pointer');
		const cursorPointerStyle = {
			width: cursorPointer.offsetWidth,
			height: cursorPointer.offsetHeight,
		};
		let cursorShadow, cursorShadowStyle;
		if (isShadowTrue) {
			cursorShadow = document.querySelector('.fls-cursor__shadow');
			cursorShadowStyle = {
				width: cursorShadow.offsetWidth,
				height: cursorShadow.offsetHeight,
			};
		}
		function mouseActions(e) {
			if (e.type === 'mouseout') {
				cursor.style.opacity = 0;
			} else if (e.type === 'mousemove') {
				cursor.style.removeProperty('opacity');
				if (
					e.target.closest('button') ||
					e.target.closest('a') ||
					e.target.closest('input') ||
					(window.getComputedStyle(e.target).cursor !== 'none' &&
						window.getComputedStyle(e.target).cursor !== 'default')
				) {
					cursor.classList.add('_hover');
				} else {
					cursor.classList.remove('_hover');
				}
			} else if (e.type === 'mousedown') {
				cursor.classList.add('_active');
			} else if (e.type === 'mouseup') {
				cursor.classList.remove('_active');
			}
			cursorPointer
				? (cursorPointer.style.transform = `translate3d(${
						e.clientX - cursorPointerStyle.width / 2
				  }px, ${e.clientY - cursorPointerStyle.height / 2}px, 0)`)
				: null;
			cursorShadow
				? (cursorShadow.style.transform = `translate3d(${
						e.clientX - cursorShadowStyle.width / 2
				  }px, ${e.clientY - cursorShadowStyle.height / 2}px, 0)`)
				: null;
		}

		window.addEventListener('mouseup', mouseActions);
		window.addEventListener('mousedown', mouseActions);
		window.addEventListener('mousemove', mouseActions);
		window.addEventListener('mouseout', mouseActions);
	}
}
//================================================================================================================================================================================================================================================================================================================
// Інші корисні функції ================================================================================================================================================================================================================================================================================================================
//================================================================================================================================================================================================================================================================================================================
// FLS (Full Logging System)
function FLS(message) {
	setTimeout(() => {
		if (window.FLS) {
			console.log(message);
		}
	}, 0);
}
// Отримати цифри з рядка
function getDigFromString(item) {
	return parseInt(item.replace(/[^\d]/g, ''));
}
// Форматування цифр типу 100 000 000
function getDigFormat(item) {
	return item.toString().replace(/(\d)(?=(\d\d\d)+([^\d]|$))/g, '$1 ');
}
// Прибрати клас з усіх елементів масиву
function removeClasses(array, className) {
	for (var i = 0; i < array.length; i++) {
		array[i].classList.remove(className);
	}
}
// Унікалізація масиву
function uniqArray(array) {
	return array.filter(function (item, index, self) {
		return self.indexOf(item) === index;
	});
}
// Функція отримання індексу всередині батьківського елемента
function indexInParent(parent, element) {
	const array = Array.prototype.slice.call(parent.children);
	return Array.prototype.indexOf.call(array, element);
}
// Функція перевіряє чи об'єкт видимий
function isHidden(el) {
	return el.offsetParent === null;
}
// Обробка медіа запитів з атрибутів
function dataMediaQueries(array, dataSetValue) {
	// Отримання об'єктів з медіа-запитами
	const media = Array.from(array).filter(function (item, index, self) {
		if (item.dataset[dataSetValue]) {
			return item.dataset[dataSetValue].split(',')[0];
		}
	});
	// Ініціалізація об'єктів з медіа-запитами
	if (media.length) {
		const breakpointsArray = [];
		media.forEach(item => {
			const params = item.dataset[dataSetValue];
			const breakpoint = {};
			const paramsArray = params.split(',');
			breakpoint.value = paramsArray[0];
			breakpoint.type = paramsArray[1] ? paramsArray[1].trim() : 'max';
			breakpoint.item = item;
			breakpointsArray.push(breakpoint);
		});
		// Отримуємо унікальні брейкпоінти
		let mdQueries = breakpointsArray.map(function (item) {
			return (
				'(' +
				item.type +
				'-width: ' +
				item.value +
				'px),' +
				item.value +
				',' +
				item.type
			);
		});
		mdQueries = uniqArray(mdQueries);
		const mdQueriesArray = [];

		if (mdQueries.length) {
			// Працюємо з кожним брейкпоінтом
			mdQueries.forEach(breakpoint => {
				const paramsArray = breakpoint.split(',');
				const mediaBreakpoint = paramsArray[1];
				const mediaType = paramsArray[2];
				const matchMedia = window.matchMedia(paramsArray[0]);
				// Об'єкти з потрібними умовами
				const itemsArray = breakpointsArray.filter(function (item) {
					if (item.value === mediaBreakpoint && item.type === mediaType) {
						return true;
					}
				});
				mdQueriesArray.push({
					itemsArray,
					matchMedia,
				});
			});
			return mdQueriesArray;
		}
	}
}

//================================================================================================================================================================================================================================================================================================================

function safeJsonParse(str, defaultValue = null) {
	try {
		return JSON.parse(str);
	} catch (e) {
		return defaultValue;
	}
}

function isObject(obj) {
	return obj && typeof obj === 'object' && !Array.isArray(obj);
}

function hashSHA256(userId, callback) {
	const encoder = new TextEncoder();
	const data = encoder.encode(userId);

	crypto.subtle.digest('SHA-256', data).then(hashBuffer => {
		// Convert the ArrayBuffer to a hexadecimal string
		const hashArray = Array.from(new Uint8Array(hashBuffer));
		const hashHex = hashArray.map(byte => byte.toString(16).padStart(2, '0')).join('');

		// Execute the callback function with the hash result
		callback(hashHex);
	});
}

function mergeObjects(target, source) {
	if (isObject(target) && isObject(source)) {
		Object.keys(source).forEach(key => {
			if (isObject(source[key])) {
				if (!target[key]) {
					Object.assign(target, { [key]: {} });
				}
				mergeObjects(target[key], source[key]);
			} else {
				Object.assign(target, { [key]: source[key] });
			}
		});
	}
	return target;
}

/**
 * True when the screen has more than one top-level sort-select without item.name
 * (nested blocks use overrideContentItemIndex with a dot and do not appear here).
 */
function sortSelectScreenHasMultipleUnnamed(screen) {
	if (!screen || !Array.isArray(screen.content)) {
		return false;
	}
	let count = 0;
	for (let i = 0; i < screen.content.length; i++) {
		const b = screen.content[i];
		if (b && b.type === 'sort-select' && (!b.name || String(b.name).trim() === '')) {
			count++;
			if (count > 1) {
				return true;
			}
		}
	}
	return false;
}

/**
 * Form / user_properties field key for sort-select (unique per block, including nested in container).
 * @param {object} item Block JSON
 * @param {object} screen Screen object (needs id for non–item.name fields)
 * @param {string|number} contentItemIndex Block index; nested blocks use "4.0" style
 * @returns {string}
 */
function getSortSelectFieldName(item, screen, contentItemIndex) {
	if (item && item.name != null && String(item.name).trim() !== '') {
		return String(item.name).trim();
	}
	const idx = String(contentItemIndex != null ? contentItemIndex : '');
	const sid = screen && screen.id != null ? String(screen.id) : '';
	if (sid && idx.indexOf('.') !== -1) {
		return sid + '_' + idx.replace(/\./g, '_');
	}
	if (sid && sortSelectScreenHasMultipleUnnamed(screen)) {
		return sid + '_' + idx.replace(/\./g, '_');
	}
	if (sid) {
		return sid;
	}
	return 'sort_select_' + idx.replace(/\./g, '_');
}

/**
 * Flattens a nested object into a flat object with dot-notation keys
 * @param {object} obj - The object to flatten
 * @param {string} prefix - Optional prefix for all keys (e.g., "selected_subscription")
 * @returns {object} A flat object with keys like "prefix.key1.key2" or "prefix.key.0" for arrays
 * @example
 * flattenObject({ a: { b: { c: 1 } } }, "prefix")
 * // Returns: { "prefix.a.b.c": 1 }
 * flattenObject({ items: [1, 2, 3] }, "data")
 * // Returns: { "data.items.0": 1, "data.items.1": 2, "data.items.2": 3 }
 */
function flattenObject(obj, prefix = '') {
	if (!isObject(obj) || obj === null) {
		return {};
	}

	const flattened = {};

	Object.keys(obj).forEach(key => {
		const value = obj[key];
		const newKey = prefix ? `${prefix}.${key}` : key;

		if (Array.isArray(value)) {
			// Handle arrays
			if (value.length === 0) {
				// Empty array returns empty string
				flattened[newKey] = "";
			} else {
				// Flatten array with index keys
				value.forEach((item, index) => {
					const arrayKey = `${newKey}.${index}`;
					if (isObject(item) && !Array.isArray(item) && item !== null) {
						// Recursively flatten nested objects in array
						const nestedFlattened = flattenObject(item, arrayKey);
						Object.assign(flattened, nestedFlattened);
					} else {
						// Add non-object values directly
						flattened[arrayKey] = item;
					}
				});
			}
		} else if (isObject(value) && value !== null) {
			// Recursively flatten nested objects
			const nestedFlattened = flattenObject(value, newKey);
			Object.assign(flattened, nestedFlattened);
		} else {
			// Add non-object values directly
			flattened[newKey] = value;
		}
	});

	return flattened;
}




// Клас Popup
class Popup {
	constructor(options) {
		let config = {
			logging: true,
			init: true,
			//Для кнопок
			attributeOpenButton: 'data-popup', // Атрибут для кнопки, яка викликає попап
			attributeCloseButton: 'data-close', // Атрибут для кнопки, що закриває попап
			// Для сторонніх об'єктів
			fixElementSelector: '[data-lp]', // Атрибут для елементів із лівим паддингом (які fixed)
			// Для об'єкту попапа
			youtubeAttribute: 'data-popup-youtube', // Атрибут для коду youtube
			youtubePlaceAttribute: 'data-popup-youtube-place', // Атрибут для вставки ролика youtube
			setAutoplayYoutube: true,
			// Зміна класів
			classes: {
				popup: 'popup',
				// popupWrapper: 'popup__wrapper',
				popupContent: 'popup__content',
				popupActive: 'popup_show', // Додається для попапа, коли він відкривається
				bodyActive: 'popup-show', // Додається для боді, коли попап відкритий
			},
			focusCatch: true, // Фокус усередині попапа зациклений
			closeEsc: true, // Закриття ESC
			bodyLock: true, // Блокування скролла
			hashSettings: {
				location: true, // Хеш в адресному рядку
				goHash: true, // Перехід по наявності в адресному рядку
			},
			on: {
				// Події
				beforeOpen: function () {},
				afterOpen: function () {},
				beforeClose: function () {},
				afterClose: function () {},
			},
		};
		this.youTubeCode;
		this.isOpen = false;
		// Поточне вікно
		this.targetOpen = {
			selector: false,
			element: false,
		};
		// Попереднє відкрите
		this.previousOpen = {
			selector: false,
			element: false,
		};
		// Останнє закрите
		this.lastClosed = {
			selector: false,
			element: false,
		};
		this._dataValue = false;
		this.hash = false;

		this._reopen = false;
		this._selectorOpen = false;

		this.lastFocusEl = false;
		this._focusEl = [
			'a[href]',
			'input:not([disabled]):not([type="hidden"]):not([aria-hidden])',
			'button:not([disabled]):not([aria-hidden])',
			'select:not([disabled]):not([aria-hidden])',
			'textarea:not([disabled]):not([aria-hidden])',
			'area[href]',
			'iframe',
			'object',
			'embed',
			'[contenteditable]',
			'[tabindex]:not([tabindex^="-"])',
		];
		//this.options = Object.assign(config, options);
		this.options = {
			...config,
			...options,
			classes: {
				...config.classes,
				...options?.classes,
			},
			hashSettings: {
				...config.hashSettings,
				...options?.hashSettings,
			},
			on: {
				...config.on,
				...options?.on,
			},
		};
		this.bodyLock = false;
		this.options.init ? this.initPopups() : null;
	}
	initPopups() {
		this.popupLogging(`Прокинувся`);
		this.eventsPopup();
	}
	eventsPopup() {
		// Клік по всьому документі
		document.addEventListener(
			'click',
			function (e) {
				// Клік по кнопці "відкрити"
				const buttonOpen = e.target.closest(
					`[${this.options.attributeOpenButton}]`,
				);
				if (buttonOpen) {
					e.preventDefault();
					this._dataValue = buttonOpen.getAttribute(
						this.options.attributeOpenButton,
					)
						? buttonOpen.getAttribute(this.options.attributeOpenButton)
						: 'error';
					this.youTubeCode = buttonOpen.getAttribute(
						this.options.youtubeAttribute,
					)
						? buttonOpen.getAttribute(this.options.youtubeAttribute)
						: null;
					if (this._dataValue !== 'error') {
						if (!this.isOpen) this.lastFocusEl = buttonOpen;
						this.targetOpen.selector = `${this._dataValue}`;
						this._selectorOpen = true;
						this.open();
						return;
					} else
						this.popupLogging(
							`Йой, не заповнено атрибут у ${buttonOpen.classList}`,
						);

					return;
				}
				// Закриття на порожньому місці (popup__wrapper) та кнопки закриття (popup__close) для закриття
				const buttonClose = e.target.closest(
					`[${this.options.attributeCloseButton}]`,
				);
				if (
					buttonClose ||
					(!e.target.closest(`.${this.options.classes.popupContent}`) &&
						this.isOpen)
				) {
					e.preventDefault();
					this.close();
					return;
				}
			}.bind(this),
		);
		// Закриття ESC
		document.addEventListener(
			'keydown',
			function (e) {
				if (
					this.options.closeEsc &&
					e.which == 27 &&
					e.code === 'Escape' &&
					this.isOpen
				) {
					e.preventDefault();
					this.close();
					return;
				}
				if (this.options.focusCatch && e.which == 9 && this.isOpen) {
					this._focusCatch(e);
					return;
				}
			}.bind(this),
		);

		// Відкриття по хешу
		if (this.options.hashSettings.goHash) {
			// Перевірка зміни адресного рядка
			window.addEventListener(
				'hashchange',
				function () {
					if (window.location.hash) {
						this._openToHash();
					} else {
						this.close(this.targetOpen.selector);
					}
				}.bind(this),
			);

			window.addEventListener(
				'load',
				function () {
					if (window.location.hash) {
						this._openToHash();
					}
				}.bind(this),
			);
		}
	}
	async open(selectorValue) {
		if (bodyLockStatus) {
			// Якщо перед відкриттям попапа був режим lock
			this.bodyLock =
				document.documentElement.classList.contains('lock') && !this.isOpen
					? true
					: false;

			// Якщо ввести значення селектора (селектор настроюється в options)
			if (
				selectorValue &&
				typeof selectorValue === 'string' &&
				selectorValue.trim() !== ''
			) {
				this.targetOpen.selector = selectorValue;
				this._selectorOpen = true;
			}
			if (this.isOpen) {
				this._reopen = true;
				this.close();
			}
			if (!this._selectorOpen)
				this.targetOpen.selector = this.lastClosed.selector;
			if (!this._reopen) this.previousActiveElement = document.activeElement;

			this.targetOpen.element = document.querySelector(
				this.targetOpen.selector,
			);

			if (this.targetOpen.element) {
				// YouTube
				if (this.youTubeCode) {
					const codeVideo = this.youTubeCode;
					const urlVideo = `https://www.youtube.com/embed/${codeVideo}?rel=0&showinfo=0&autoplay=1`;
					const iframe = document.createElement('iframe');
					iframe.setAttribute('allowfullscreen', '');

					const autoplay = this.options.setAutoplayYoutube ? 'autoplay;' : '';
					iframe.setAttribute('allow', `${autoplay}; encrypted-media`);

					iframe.setAttribute('src', urlVideo);

					if (
						!this.targetOpen.element.querySelector(
							`[${this.options.youtubePlaceAttribute}]`,
						)
					) {
						const youtubePlace = this.targetOpen.element
							.querySelector('.popup__text')
							.setAttribute(`${this.options.youtubePlaceAttribute}`, '');
					}
					this.targetOpen.element
						.querySelector(`[${this.options.youtubePlaceAttribute}]`)
						.appendChild(iframe);
				}

				// До відкриття
				const callbackBeforeOpen = await this.options.on.beforeOpen(this);
				if (callbackBeforeOpen === false) {
					return;
				}

				if (this.options.hashSettings.location) {
					// Отримання хешу та його виставлення
					this._getHash();
					this._setHash();
				}

				// Створюємо свою подію після відкриття попапа
				document.dispatchEvent(
					new CustomEvent('beforePopupOpen', {
						detail: {
							popup: this,
						},
					}),
				);

				this.targetOpen.element.classList.add(this.options.classes.popupActive);
				document.documentElement.classList.add(this.options.classes.bodyActive);

				if (!this._reopen) {
					!this.bodyLock ? bodyLock() : null;
				} else this._reopen = false;

				this.targetOpen.element.setAttribute('aria-hidden', 'false');

				// Запам'ятаю це відчинене вікно. Воно буде останнім відкритим
				this.previousOpen.selector = this.targetOpen.selector;
				this.previousOpen.element = this.targetOpen.element;

				this._selectorOpen = false;

				this.isOpen = true;

				setTimeout(() => {
					this._focusTrap();
				}, 50);

				// Після відкриття
				this.options.on.afterOpen(this);
				// Створюємо свою подію після відкриття попапа
				document.dispatchEvent(
					new CustomEvent('afterPopupOpen', {
						detail: {
							popup: this,
						},
					}),
				);
				this.popupLogging(`Відкрив попап`);
			} else
				this.popupLogging(
					`Йой, такого попапу немає. Перевірте коректність введення. `,
				);
		}
	}
	close(selectorValue) {
		if (
			selectorValue &&
			typeof selectorValue === 'string' &&
			selectorValue.trim() !== ''
		) {
			this.previousOpen.selector = selectorValue;
		}
		if (!this.isOpen || !bodyLockStatus) {
			return;
		}
		// До закриття
		this.options.on.beforeClose(this);
		// Створюємо свою подію перед закриттям попапа
		document.dispatchEvent(
			new CustomEvent('beforePopupClose', {
				detail: {
					popup: this,
				},
			}),
		);

		// YouTube
		if (this.youTubeCode) {
			if (
				this.targetOpen.element.querySelector(
					`[${this.options.youtubePlaceAttribute}]`,
				)
			)
				this.targetOpen.element.querySelector(
					`[${this.options.youtubePlaceAttribute}]`,
				).innerHTML = '';
		}
		this.previousOpen.element.classList.remove(
			this.options.classes.popupActive,
		);
		// aria-hidden
		this.previousOpen.element.setAttribute('aria-hidden', 'true');
		if (!this._reopen) {
			document.documentElement.classList.remove(
				this.options.classes.bodyActive,
			);
			!this.bodyLock ? bodyUnlock() : null;
			this.isOpen = false;
		}
		// Очищення адресного рядка
		this._removeHash();
		if (this._selectorOpen) {
			this.lastClosed.selector = this.previousOpen.selector;
			this.lastClosed.element = this.previousOpen.element;
		}
		// Після закриття
		this.options.on.afterClose(this);
		// Створюємо свою подію після закриття попапа
		document.dispatchEvent(
			new CustomEvent('afterPopupClose', {
				detail: {
					popup: this,
				},
			}),
		);

		setTimeout(() => {
			this._focusTrap();
		}, 50);

		this.popupLogging(`Закрив попап`);
	}
	// Отримання хешу
	_getHash() {
		if (this.options.hashSettings.location) {
			this.hash = this.targetOpen.selector.includes('#')
				? this.targetOpen.selector
				: this.targetOpen.selector.replace('.', '#');
		}
	}
	_openToHash() {
		let classInHash = document.querySelector(`${window.location.hash}`)
				? `${window.location.hash}`
				: null;

		if (classInHash) {
			const buttons = document.querySelector(
				`[${this.options.attributeOpenButton} = "${classInHash}"]`,
			)
				? document.querySelector(
					`[${this.options.attributeOpenButton} = "${classInHash}"]`,
				)
				: document.querySelector(
					`[${this.options.attributeOpenButton} = "${classInHash.replace(
						'.',
						'#',
					)}"]`,
				);

			if (buttons) {
				this.youTubeCode = buttons.getAttribute(this.options.youtubeAttribute)
					? buttons.getAttribute(this.options.youtubeAttribute)
					: null;
			}
		}

		if (classInHash) this.open(classInHash);
	}
	// Встановлення хеша
	_setHash() {
		history.pushState('', '', this.hash);
	}
	_removeHash() {
		history.pushState('', '', window.location.href.split('#')[0]);
	}
	_focusCatch(e) {
		const focusable = this.targetOpen.element.querySelectorAll(this._focusEl);
		const focusArray = Array.prototype.slice.call(focusable);
		const focusedIndex = focusArray.indexOf(document.activeElement);

		if (e.shiftKey && focusedIndex === 0) {
			focusArray[focusArray.length - 1].focus();
			e.preventDefault();
		}
		if (!e.shiftKey && focusedIndex === focusArray.length - 1) {
			focusArray[0].focus();
			e.preventDefault();
		}
	}
	_focusTrap() {
		const focusable = this.previousOpen.element.querySelectorAll(this._focusEl);
		if (!this.isOpen && this.lastFocusEl) {
			this.lastFocusEl.focus();
		} else {
			focusable[0].focus();
		}
	}
	// Функція виведення в консоль
	popupLogging(message) {
		//this.options.logging ? FLS(`[Попапос]: ${message}`) : null;
	}
}


function promptForEmail() {
	let email = "";
	const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

	email = prompt("Please enter your email address:");
	if (!emailPattern.test(email)) {
		alert("Invalid email format. Please try again.");
		return false;
	}

	return email;
}

// Check if the element is visible in the viewport
function isElementInViewport(el, minRequiredHeight) {
	minRequiredHeight = minRequiredHeight ? minRequiredHeight : 50;
	const rect = el.getBoundingClientRect();
	const visibleHeight = Math.min(rect.bottom, window.innerHeight) - Math.max(rect.top, 0);
	return visibleHeight >= minRequiredHeight;
}

function debounce(func, wait) {
	let timeout;
	return function (...args) {
		const context = this;
		clearTimeout(timeout);
		timeout = setTimeout(() => func.apply(context, args), wait);
	};
}

function getCssPathJQuery($element) {
	if (!$element || !$element.length) return null;

	const path = [];
	while ($element.length && $element[0].nodeType === Node.ELEMENT_NODE) {
		let selector = $element.prop("nodeName").toLowerCase();

		// Add ID if it exists
		if ($element.attr("id")) {
			selector += `#${$element.attr("id")}`;
			path.unshift(selector);
			break; // Stop if we find an ID
		}

		// Add classes if they exist
		if ($element.attr("class")) {
			const classes = $element.attr("class").split(/\s+/).join(".");
			selector += `.${classes}`;
		}

		// Add nth-child if necessary
		const $siblings = $element.parent().children($element.prop("nodeName").toLowerCase());
		if ($siblings.length > 1) {
			selector += `:nth-child(${ $siblings.index($element) + 1 })`;
		}

		path.unshift(selector);
		$element = $element.parent();
	}

	return path.join(" > ");
}

function isFunctionString(str) {
	try {
		if (['Promise', 'Array', 'Object', 'String', 'Number', 'History'].includes(str)) {
			return false;
		}
		if (window[str]) {
			return false;
		}
		// Attempt to create a function from the string
		const func = new Function(`return (${str})`); // This checks if the string has valid function syntax

		// If no error, check if the result is a function
		return typeof func() === 'function'; // Ensure the result is a function
	} catch (e) {
		// If an error occurs, the string doesn't represent a valid function
		return false;
	}
}

function evaluateFunction (functionText, context, callback) {
// Create the function from the text
	const generatedFunction = new Function(`return (${functionText})`)(); // Invoke the function constructor
	return generatedFunction(context, callback);
}

function typeEffect($element, speed, callback) {
	if (!speed) {
		speed = 15;
	}
	let originalNodes = $element.contents().clone(); // Clone original nodes
	$element.empty(); // Clear original content

	function typeNode(index) {
		if (index >= originalNodes.length) {
			if (callback) callback(); // Callback when finished
			return;
		}

		let node = originalNodes[index];

		if (node.nodeType === Node.TEXT_NODE) {
			// Typing effect for text nodes
			let text = node.nodeValue;
			let span = $("<span></span>");
			$element.append(span);
			let i = 0;

			function typeText() {
				if (i < text.length) {
					span.append(text.charAt(i));
					i++;
					setTimeout(typeText, speed);
				} else {
					typeNode(index + 1); // Move to next node after typing text
				}
			}
			typeText();

		} else if (node.nodeType === Node.ELEMENT_NODE) {
			// Handle HTML elements (strong, br, etc.)
			let $newElement = $(node).clone(); // Clone element but remove content
			$element.append($newElement);

			// Recursively type inside the element
			typeEffect($newElement, speed, () => {
				typeNode(index + 1); // Move to the next node after finishing the child element
			});
		} else {
			typeNode(index + 1); // Skip unsupported node types
		}
	}

	typeNode(0);
}

function loadingSpinner(start = 1) {
	if (start) {
		document.querySelector('body').classList.add('loading-page');
	} else {
		document.querySelector('body').classList.remove('loading-page');
	}
}

function expandHex(color) {
	return color.replace(/^#([0-9a-fA-F])([0-9a-fA-F])([0-9a-fA-F])$/, "#$1$1$2$2$3$3");
}

/**
 * Escape HTML entities for safe storage in HTML attributes
 * Uses browser-native string replacement methods
 * @param {string} html - HTML string to escape
 * @returns {string} Escaped HTML string safe for attributes
 */
function escapeHtmlForAttribute(html) {
	if (html == null || html === '') return '';
	const str = String(html);
	return str
		.replace(/&/g, '&amp;')
		.replace(/</g, '&lt;')
		.replace(/>/g, '&gt;')
		.replace(/"/g, '&quot;')
		.replace(/'/g, '&#39;');
}

/**
 * Properly encodes a URL, especially query parameter values.
 * This ensures that special characters in query parameters (like +, @, etc.) are properly encoded.
 * Note: We manually parse and encode to avoid URLSearchParams interpreting + as space.
 * @param {string} urlString - The URL string to encode
 * @returns {string} - The properly encoded URL
 */
function encodeUrl(urlString) {
	if (!urlString || typeof urlString !== 'string') {
		return urlString;
	}

	// Check if URL has query parameters
	const queryIndex = urlString.indexOf('?');
	if (queryIndex === -1) {
		// No query string, return as-is
		return urlString;
	}

	const baseUrl = urlString.substring(0, queryIndex);
	const queryAndHash = urlString.substring(queryIndex + 1);
	const hashIndex = queryAndHash.indexOf('#');
	const hash = hashIndex !== -1 ? queryAndHash.substring(hashIndex) : '';
	const queryString = hashIndex !== -1 ? queryAndHash.substring(0, hashIndex) : queryAndHash;

	if (!queryString) {
		// Empty query string, return as-is
		return urlString;
	}

	// Manually parse and encode query parameters
	// This avoids URLSearchParams interpreting + as space
	const paramPairs = queryString.split('&');
	const encodedParams = paramPairs.map(pair => {
		const equalIndex = pair.indexOf('=');
		if (equalIndex === -1) {
			// No value, just encode the key
			return encodeURIComponent(pair);
		}
		const key = pair.substring(0, equalIndex);
		const value = pair.substring(equalIndex + 1);
		// Encode both key and value to ensure special characters are properly encoded
		return encodeURIComponent(key) + '=' + encodeURIComponent(value);
	});

	return baseUrl + '?' + encodedParams.join('&') + hash;
}

function checkSubscriptionStatus(paymentSystem, paySystemId, priceId) {
	const urlParams = new URLSearchParams(window.location.search);
	let data = {};
	for (const [key, value] of urlParams.entries()) {
		data[key] = value;
	}

	data.payment_system = paymentSystem;
	data.pay_system_id = paySystemId;
	data.price_id = priceId;

	return fetch(
		'/payment/subscription-check-status',
		{
			method: "POST",
			headers: {
				"Accept": "application/json",
				"Content-type": "application/json",
			},
			body: JSON.stringify(data),
		}
	).then(response => {
		// if (!response.ok) {
		// }
		return response.json();
	})
}

async function waitSubscriptionCompleted(paymentSystem, paySystemId, priceId, maxAttempts = 10, sleepMs = 500) {
	for (let attempt = 0; attempt < maxAttempts; attempt++) {
		const data = await checkSubscriptionStatus(paymentSystem, paySystemId, priceId);
		if (data.status === 'completed') {
			return data;
		}
		if (data.status !== 'wait') {
			throw new Error(data.message || `Payment status: ${data.status}`);
		}
		await w2wSleep(sleepMs);
	}
	throw new Error('Payment confirmation timeout');
}
